/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Phone/Fields/Type"
  
}) {
let typesValueData = fromData.useDataValue({ viewPath,
context: 'types',
})
let newRelationPhoneTypeValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'phone.type',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="types"
 from={typesValueData}
 data="new_relation.phone.type"
 value={newRelationPhoneTypeValueData}
 onChange={onChange}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Type"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}